<div id="container" class="container content">
  <div id="informacoes-sociodemograficas">
    <div class="flex justify-between mb-6">
      <h1 class="text-orange-400 text-heading-lg text-semibold m-0">
        Informações sociodemográficas
      </h1>

      <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer"
      (click)="baixarPdfInformacoesSociodemograficas()">
    </div>

    <div class="table-content rounded-sm sm-shadow">
      <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-header left-header right-header text-body-lg text-bold text-blue-500-important ">Informações sociodemográficas</th>
          </tr>
        </ng-container>

        <ng-container corpo *ngIf="socioDemograficas">
          <tr class="cells-row">
            <td class="left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>População estimada <sup>(1)</sup>: </span>
              <span>{{ socioDemograficas.quantidadePopulacao | number:'1.0-0':'pt-BR' }}</span>
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>PIB per capita <sup>(2) (3)</sup>: </span>
              <span>{{ socioDemograficas.pibPerCapita | number:'1.0-0':'pt-BR' }}</span>
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>IDHM <sup>(4)</sup>: </span>
              <span>{{socioDemograficas.valorIdh}}</span>
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>IDHM por nível<sup></sup>: </span>
              <span>{{socioDemograficas.nivelIdh}}</span>
            </td>
          </tr>
        </ng-container>
      </app-tabela>

      <!-- Exibe Quintil do Municipio -->
      <app-tabela [cabecalhoCustomizado]="true" class="mt-6" *ngIf="deveExibirQuintilMunicipio" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-header left-header right-header text-body-lg bg-gray-100 align-start">PIB per capita por quintil</th>
          </tr>
        </ng-container>
        <ng-container corpo *ngIf="quintilMunicipio">
          <tr class="cells-row">
            <td class="bottom-left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>{{ quintilMunicipio.dscClassificacao }}: </span>
              <span *ngIf="quintilMunicipio.vlrQuintil !== null">
                {{ quintilMunicipio.vlrQuintil | number:'1.0-0':'pt-BR' }}
              </span>
              <span *ngIf="quintilMunicipio.vlrQuintil === null">sem valor informado</span>
            </td>
          </tr>
        </ng-container>
      </app-tabela>

      <!-- Estado/Nacional - lista dos 5 quintis -->
      <app-tabela [cabecalhoCustomizado]="true" class="mt-6" *ngIf="!deveExibirQuintilMunicipio" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-header left-header right-header text-body-lg bg-gray-100 align-start">
              PIB per capita por quintil
            </th>
          </tr>
        </ng-container>

        <ng-container corpo>
          <tr class="cells-row" *ngFor="let q of quintisDadosSocioeconomicos; let last = last">
            <td class="bottom-left-cell right-cell text-body-lg text-charcoal-800-important align-start">
              <span>{{ q.nivelProdutoInternoBruto.dscClassificacao }}: </span>
              <span *ngIf="q.vlrQuintil !== null">
                {{ q.vlrQuintil | number:'1.0-0':'pt-BR' }}
              </span>
              <span *ngIf="q.vlrQuintil === null">sem valor informado</span>
            </td>
          </tr>
        </ng-container>
      </app-tabela>


      <div class="notas mt-4">
        <p class="text-body-xs text-charcoal-800 m-0">Fontes:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(1)</sup>
          Elaborado a partir das Estimativas da População/IBGE 2021.
        </p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(2)</sup>
          Elaborado a partir da base de Produto Interno Bruto dos Municípios e Estimativas da População/IBGE 2021.
        </p>
        <p class="text-body-xs text-charcoal-800 m-0">Notas:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(3)</sup>
          O PIB per capita é calculado pelo IBGE em nível municipal. Portanto, o PIB per capita em nível nacional é resultado da soma dos PIB municipais dividido pela soma da população de todos os municípios. Da mesma forma, o PIB per capita no nível estadual é resultado da soma do PIB dos municípios de cada estado dividido pela soma das respectivas populações.
        </p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(4)</sup>
          Elaborado pelo Atlas do Desenvolvimento Humano no Brasil/PNUD (com dados do Censo de 2010) disponibilizados em 2013.
        </p>
      </div>
    </div>
  </div>

  <div id="informacoes-educacionais">
    <div class="flex justify-between mb-6 mt-16">
      <h1 class="text-orange-400 text-heading-lg text-semibold m-0">
        Informações educacionais
      </h1>
      <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer"
      (click)="baixarPdfInformacoesEducacionais()">
    </div>

    <!-- Informacoes Educacionais - Numero de Escolas -->
    <div class="table-content rounded-sm sm-shadow mb-8">
      <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-left-header text-body-lg" rowspan="2" style="width: 30%;">Dependência administrativa</th>
            <th class="top-right-header text-body-lg" colspan="3">
              Número de escolas <sup>(4) (5)</sup>
            </th>
          </tr>
          <tr class="header-row">
            <th class="text-body-lg align-start" (click)="ordenarTabelaEscolas('urbana')">
              <div class="sort-container">
                <span>Urbana</span>
                <img [src]="obterIconeOrdenacaoEscolas('urbana')"
                    alt="Ordenar por Urbana"
                    class="sort-icon">
              </div>
            </th>
            <th class="text-body-lg align-start" (click)="ordenarTabelaEscolas('rural')">
              <div class="sort-container">
                <span>Rural</span>
                <img [src]="obterIconeOrdenacaoEscolas('rural')"
                    alt="Ordenar por Rural"
                    class="sort-icon">
              </div>
            </th>
            <th class="right-header text-body-lg align-start" (click)="ordenarTabelaEscolas('total')">
              <div class="sort-container">
                <span>Total</span>
                <img [src]="obterIconeOrdenacaoEscolas('total')"
                    alt="Ordenar por Total"
                    class="sort-icon">
              </div>
            </th>
          </tr>
        </ng-container>

        <ng-container corpo *ngIf="dadosEducacionaisEscolas?.length">
          <!-- Usar dependências ordenadas -->
          <tr class="cells-row" *ngFor="let dep of obterDependenciasOrdenadasEscolas()">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">{{ dep }}</td>
            <td class="text-body-lg text-charcoal-800-important align-start">{{ somarEscolas(dep,'Urbana') | number:'1.0-0':'pt-BR' }}</td>
            <td class="text-body-lg text-charcoal-800-important align-start">{{ somarEscolas(dep,'Rural') | number:'1.0-0':'pt-BR' }}</td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">
              {{ somarEscolas(dep,'Urbana') + somarEscolas(dep,'Rural') | number:'1.0-0':'pt-BR' }}
            </td>
          </tr>
          <tr class="cells-row">
            <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">Total</td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalEscolas('Urbana') | number:'1.0-0':'pt-BR' }}
            </td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalEscolas('Rural') | number:'1.0-0':'pt-BR' }}
            </td>
            <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalEscolas('Urbana') + calcularTotalEscolas('Rural') | number:'1.0-0':'pt-BR' }}
            </td>
          </tr>
        </ng-container>
      </app-tabela>

      <div class="notas mt-4">
        <p class="text-body-xs text-charcoal-800 m-0">Fontes:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(4)</sup>
          Elaborado a partir dos dos microdados do Censo Escolar/INEP 2025.
        </p>
        <p class="text-body-xs text-charcoal-800 m-0">Notas:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(5)</sup>
          A contagem do número de estabelecimentos considera apenas aqueles informados como 'em atividade' no ano do Censo e que tinham pelo menos uma matrícula de Ensino Regular, Educação de Jovens e Adultos (EJA) e/ou Educação Profissional.
        </p>
      </div>
    </div>

    <!-- Informacoes Educacionais - Numero de Matriculas-->
    <div class="table-content rounded-sm sm-shadow mb-13">
      <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-left-header text-body-lg" rowspan="2" style="width: 30%;">Dependência administrativa</th>
            <th class="top-right-header text-body-lg" colspan="3">
              Número de matrículas <sup>(6) (7)</sup>
            </th>
          </tr>
          <tr class="header-row">
            <th class="text-body-lg align-start" (click)="ordenarTabelaMatriculas('urbana')">
              <div class="sort-container">
                <span>Urbana</span>
                <img [src]="obterIconeOrdenacaoMatriculas('urbana')"
                    alt="Ordenar por Urbana"
                    class="sort-icon">
              </div>
            </th>
            <th class="text-body-lg align-start" (click)="ordenarTabelaMatriculas('rural')">
              <div class="sort-container">
                <span>Rural</span>
                <img [src]="obterIconeOrdenacaoMatriculas('rural')"
                    alt="Ordenar por Rural"
                    class="sort-icon">
              </div>
            </th>
            <th class="right-header text-body-lg align-start" (click)="ordenarTabelaMatriculas('total')">
              <div class="sort-container">
                <span>Total</span>
                <img [src]="obterIconeOrdenacaoMatriculas('total')"
                    alt="Ordenar por Total"
                    class="sort-icon">
              </div>
            </th>
          </tr>
        </ng-container>

        <ng-container corpo *ngIf="dadosEducacionaisMatriculas?.length">
          <!-- Usar dependências ordenadas -->
          <tr class="cells-row" *ngFor="let dep of obterDependenciasOrdenadasMatriculas()">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">{{ dep }}</td>
            <td class="text-body-lg text-charcoal-800-important align-start">{{ somarMatriculas(dep,'Urbana') | number:'1.0-0':'pt-BR' }}</td>
            <td class="text-body-lg text-charcoal-800-important align-start">{{ somarMatriculas(dep,'Rural') | number:'1.0-0':'pt-BR' }}</td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">
              {{ somarMatriculas(dep,'Urbana') + somarMatriculas(dep,'Rural') | number:'1.0-0':'pt-BR' }}
            </td>
          </tr>
          <tr class="cells-row">
            <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">Total</td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalMatriculas('Urbana') | number:'1.0-0':'pt-BR' }}
            </td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalMatriculas('Rural') | number:'1.0-0':'pt-BR' }}
            </td>
            <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
              {{ calcularTotalMatriculas('Urbana') + calcularTotalMatriculas('Rural') | number:'1.0-0':'pt-BR' }}
            </td>
          </tr>
        </ng-container>
      </app-tabela>

      <div class="notas mt-4">
        <p class="text-body-xs text-charcoal-800 m-0">Fontes:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(6)</sup>
          Elaborado a partir dos dos microdados do Censo Escolar/INEP 2025.
        </p>
        <p class="text-body-xs text-charcoal-800 m-0">Notas:</p>
        <p class="text-body-xs text-charcoal-800 m-0">
          <sup>(7)</sup>
          A contagem de matrículas segue os mesmos critérios adotados pelo INEP: (a) O mesmo aluno pode ter mais de uma matrícula; (b) Não inclui matrículas de turmas de Atendimento Complementar e Atendimento Educacional Especializado (AEE); (c) Inclui matrículas do Ensino Regular, Especial e/ ou Educação de Jovens e Adultos(EJA).
        </p>
      </div>
    </div>
  </div>
</div>
